"use client";

import { useIsDomReady } from "@/hooks/IsDomReady";
import { useConversionCritical, useIdleReady } from "../tagGate";

/**
 * Is it time to fire analytics?
 *
 * Same contract as before — conversion-critical pages (checkout result / `track_id`)
 * fire on full DOM-ready, everywhere else fires once the browser is idle after first
 * paint. This keeps the heavy third-party JS (Smartlook recorder / GTM / GA / pixels)
 * off the first-interaction frame while still firing for visitors who never interact.
 *
 * The difference is that the idle timer, the router subscription and the state now
 * live in ONE shared module store instead of one copy per consumer. See `tagGate.ts`
 * for the measured reason. Consumers are unchanged.
 */
const useShouldFire = () => {
  const idleReady = useIdleReady();
  const isDomReady = useIsDomReady();
  const critical = useConversionCritical();

  return critical ? isDomReady : idleReady;
};

export default useShouldFire;
